var map = {
	"./ativo.png": 697,
	"./audio.png": 60,
	"./avaliacao.png": 39,
	"./avaliacao_old.png": 698,
	"./competencia.png": 241,
	"./compress.png": 161,
	"./dirigido.png": 80,
	"./download.png": 61,
	"./excel.png": 164,
	"./html.png": 66,
	"./images.png": 58,
	"./inativo.png": 699,
	"./link.png": 54,
	"./pasta.png": 79,
	"./pdf.png": 35,
	"./powerpoint.png": 165,
	"./presencas.png": 124,
	"./progresso.png": 42,
	"./questionario-satisfacao.png": 125,
	"./questionario.png": 37,
	"./relatorio.png": 83,
	"./sessao-presencial.png": 62,
	"./sumario.png": 69,
	"./text.png": 163,
	"./trabalho_colaborativo.png": 46,
	"./trabalho_grupo.png": 45,
	"./trabalho_individual.png": 44,
	"./video.png": 71,
	"./webinar.png": 323,
	"./word.png": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 696;